// Fixed system roles, mirroring the backend (src/auth/roles.py). The UI uses the
// user's role to show/hide actions; enforcement always happens on the backend.
//
// These are pure helpers (no React). The LIVE role for the signed-in user comes
// from the AuthProvider — use `useAuth()` / `usePermissions()` from
// `context/AuthContext` in components so the role stays fresh, rather than
// reading the (possibly stale) localStorage snapshot directly.
export const ROLES = { ADMIN: 'admin', EDITOR: 'editor', VIEWER: 'viewer' };

const VALID_ROLES = new Set([ROLES.ADMIN, ROLES.EDITOR, ROLES.VIEWER]);

export function getStoredUser() {
    try {
        const raw = localStorage.getItem('user');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

/** Resolve a user's role, defaulting to the least-privileged role. */
export function getUserRole(user) {
    const u = user || getStoredUser();
    if (!u) return ROLES.VIEWER;
    if (typeof u.role === 'string' && VALID_ROLES.has(u.role)) return u.role;
    return ROLES.VIEWER;
}

export const isAdminRole = (user) => getUserRole(user) === ROLES.ADMIN;
export const isEditorRole = (user) => getUserRole(user) === ROLES.EDITOR;
export const isViewerRole = (user) => getUserRole(user) === ROLES.VIEWER;
/** Editor + admin may create/run/mutate; viewers are read-only. */
export const canWrite = (user) => getUserRole(user) !== ROLES.VIEWER;
